import $ from "jquery";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Odometer from 'odometer';



const animateStatistics = () => {

	let statsArr = gsap.utils.toArray('.statistics__content')

	statsArr.forEach((item, index) => {

		let statsTl = gsap.timeline({
			scrollTrigger: {
				onEnter: () => {

					$(item).find(".statistics__item-figure").each(function () {
					
						let $this = $(this),
        		countTo = $this.attr('data-count');

						let splittedArray = countTo?.replace(/[^0-9_.]/g, '')

						let text = countTo?.replace(splittedArray, '')

						if (!splittedArray) return

						$this.parent().find('.statistics__item-text').append(text)
						setTimeout(() => {
							$this.parent().find('.statistics__item-text').addClass('statistics__item-text-effect')
						}, 2200);
						
						let odometer = new Odometer({
							el: $this[0],
							value: 0,
							format: '(,ddd)'
						});


							// Update the value after a specific delay
							setTimeout(function() {
								odometer.update(parseFloat(splittedArray));
							}, 200); // Adjust the duration as needed (e.g., 1000 milliseconds = 1 second)
					
					})

				},
				once: true,
				trigger: item
			}
		})
	
	})

}


$(function() {
	animateStatistics()
});

